import { useMemo } from "react";
import { useAuthContext } from "providers/Auth";
import { getActiveRoutes } from "providers/Routes/active/routes";
import { isPathAvailable, toRouteObjects } from "./route-match";

export const usePortalPathAvailable = () => {
  const { type, permissions } = useAuthContext();
  const routes = useMemo(
    () => toRouteObjects(getActiveRoutes(type, permissions)),
    [type, permissions]
  );
  return (path: string | null) =>
    path !== null && isPathAvailable(routes, path);
};
